
import { Component, Input, OnInit } from '@angular/core';

import { UiService } from '../../../../services/core.ui.service';
import { GfTranslateService } from '../../../../services/core.translate.service';
import { ProjectReportsData } from '../../services/project.reports.data.service';
import { ProjectService } from '../../../../services/project.service';
import { FilterService } from '../../../../services/core.filter.service';
import { StateService } from '@uirouter/angular';
import { TeamReportHelper } from './project.report.team.service.component';
import { UserService } from '../../../../services/core.user.service';

import * as _ from 'lodash';
@Component({
    selector: 'project-team-report',
    template: require('./project.report.team.component.html')
})
export class ProjectTeamReportComponent implements OnInit {

    @Input() project: any = null;

    protected filters: any = false;
    private projects: any = [];
    protected sortFields: any = false;
    private sort: any = false;
    private paging: any = false;
    private baseFilters: any = false;
    protected reportData: any = null;
    protected loading = false;

    constructor(
        private stateService: StateService, 
        
        private userService: UserService,
        private uiService: UiService,
        private gfTranslateService: GfTranslateService,
        private projectReportsData: ProjectReportsData,
        private teamReportHelper: TeamReportHelper,
        private projectService: ProjectService,
        private filterService: FilterService,
    ) { }
    
    ngOnInit() {


        this.sortFields = this.teamReportHelper.getSortFields();
        this.sort = this.filterService.getSortValues();
        this.paging = this.filterService.getPagingValues();

        var params = {
            inOrg: this.project.unixName,
            sort_field: 'projectName',
            page_size: 100
        };

        this.projectService.search(params)
        .then(
            (response) => {
                this.projects = _.get(response, 'items', []);

                this.baseFilters = this.teamReportHelper.getBaseFilters(this.projects);
                this.filters = {
                    main_fields: this.filterService.setFilterValues(
                        this.baseFilters,
                        this.stateService.params
                    )
                };
                this.refreshData();

            }, (response) => {
                console.log(response);
                this.projects = [];
            }
        );
    };

    onApplyFilters() {
        this.paging.page_num = 1;
        this.applyFilters();
    };

    onResetFilters() {
        this.paging.page_num = 1;
        this.filters = {
            main_fields: this.filterService.setFilterValues(
                _.cloneDeep(this.baseFilters),
                {}
            )
        };

        const clearedParams = {};
        _.forEach(this.baseFilters, (filter: any) => {
            clearedParams[filter.alias] = '';
        });

        this.applyFilters(clearedParams);
    };

    onSort(params) {
        this.sort = {
            sort_field: _.get(params, 'key', 'unixName'),
            sort_dir: _.get(params, 'sortDir', 'desc')
        };
        this.applyFilters();
    };

    downloadData(format) {
        var fetchArgs = this.filterService.getFetchArgs({ project: this.stateService.params.unixName });
        this.projectReportsData.runReport(fetchArgs, format);
    };

    onPaging(params) {
        _.assignIn(this.paging, params);
        this.applyFilters();
    };

    refreshData() {
        this.loading = true;

        var fetchArgs = this.filterService.getFetchArgs(this.getParams());
        delete fetchArgs.unixName;

        this.projectService.report(fetchArgs)
            .then(
                (response) => {
                    this.reportData = _.map(
                        _.get(response, 'items', []),
                        (row) => {
                            row.projects = row.projects.replaceAll(',', ', ');
                            return row;
                        }
                    );
                },
                (response) => {
                    console.log(response);
                    this.reportData = [];
                    var msg = this.gfTranslateService.translate('There was a problem loading report data');
                    this.uiService.message.showWarning(msg, 'Data Error');
                }
            )
            .finally(
                () => {
                    this.loading = false;
                }
            );
    }

    getBaseParams() {
        return { type: 'team', unixName: this.stateService.params.unixName, project: this.stateService.params.unixName };
    }

    getParams(overrides: any = {}) {
        return Object.assign(
            this.getBaseParams(),
            this.sort,
            this.paging,
            this.filterService.getAllFilterValues(
                _.get(this.filters, 'main_fields', [])
            ),
            overrides
        );
    }

    applyFilters(overrides: any = {}) {
        var newParams = this.getParams(overrides);

        this.stateService.go('.', newParams, { inherit: false, reload: false, location: true, notify: false }).then(
            () => {
                this.refreshData();
            }
        );
    }
}
